/**
 * Returns a promise.
 *
 * @param text
 * @returns {Promise<void>}
 */
export function copyTextToClipboard(text) {
  return navigator.clipboard.writeText(text);
}